import { OrderedMap } from 'immutable';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
const searchResultsToMap = results => results.reduce((searchResultsMap, result) => {
  // @ts-expect-error TypedMap doesn't match record type
  const searchResult = SearchResultRecord.init(result);
  return searchResultsMap.set(searchResult.id, searchResult);
}, OrderedMap());
const getActions = searchFetch => {
  return {
    search: folderSearchQuery => searchFetch(folderSearchQuery).then(resultsData => ({
      hasMore: resultsData.get('hasMore'),
      results: searchResultsToMap(resultsData.get('results'))
    }))
  };
};
const FolderActions = {
  create() {
    let _actions;
    function get(action) {
      if (!_actions) {
        throw new Error('Must call init on FolderActions before retrieving actions');
      }
      return action ? _actions[action] : _actions;
    }
    return {
      init(searchFetch) {
        if (!_actions) {
          _actions = getActions(searchFetch);
        }
      },
      get
    };
  }
};
export default FolderActions.create();

// Types